/**
 * @desc 处理异常
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.fulfilment.StockAdjustmentHandleExceptionRequestDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/handleException`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
